export default __webpack_public_path__ + "static/media/ind-flag.757ee8dc.jpg";